//#region src/engine/modules/memo/actions.ts
var ActionType = {
	addMemo: "memo.add",
	moveMemo: "memo.move",
	moveToMemo: "memo.moveTo",
	removeMemo: "memo.remove",
	changeMemoValue: "memo.changeValue",
	changeMemoColor: "memo.changeColor",
	resizeMemo: "memo.resize",
	changeZIndex: "memo.changeZIndex"
};
//#endregion
export { ActionType };
